let searchInputs = [
    {
        id: 'insuranceLine',
        label: 'Insurance Line',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'underwriter',
        label: 'Underwriter',
        type: 'select',
        options: []
    },
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference'
    },
    {
        id: 'provider',
        label: 'Repair Provider',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'optionType',
        label: 'Repair Option Type',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'imei',
        label: 'IMEI',
        type: 'text',
        placeholder: 'IMEI No'
    },
    {
        id: 'serial',
        label: 'Serial',
        type: 'text',
        placeholder: 'Serial No'
    }
]

export { searchInputs }